import { setPageStateById } from '../PageContext';

export const setCustomSubtitle = (setState: setPageStateById) => (customSubtitleTId: string) => {
  setState('SET_PAGE_SUBTITLE', (s) => ({
    ...s,
    customSubtitleTId,
  }));
};
